<script>
import { mapGetters } from 'vuex'
import Roles from '@/mixins/Roles'
import Tab from '@/components/elements/tabs/Tab'
import Tabs from '@/components/elements/tabs/Tabs'
import Panel from '@/components/elements/Panel'
import Heading from '@/components/typography/Heading'
import MultiSelect from '@/components/input/MultiSelect'
import Badge from '@/components/elements/Badge'
import InputSwitch from '@/components/input/Switch'
import InputButton from '@/components/input/Button'
import InputLine from '@/components/input/Line'

export default {
    name: 'Bids',
    components: {
        InputLine,
        InputButton,
        InputSwitch,
        Badge,
        MultiSelect,
        Heading,
        Panel,
        Tabs,
        Tab,
    },
    mixins: [Roles],

    data() {
        return {
            model: {
                services: {},
                configs: {},
            },
        }
    },

    computed: {
        ...mapGetters({
            orderTypes: 'orderTypes',
            dataFetched: 'dataFetched',
            bidConfigModel: 'bidConfigModel',
        }),

        isDisabled() {
            return this.hasRoleUpdate('masterdata.packets') === false
        },
    },

    watch: {
        dataFetched: {
            handler(val) {
                if (val)
                    this.$store.dispatch('bidConfigsGenerateModel').then(() => {
                        this.model = JSON.parse(
                            JSON.stringify(this.bidConfigModel)
                        )
                        this.$refs.tabsCont.firstTabActive()
                    })
            },
            immediate: true,
        },
    },

    mounted() {
        this.setTitle()
    },

    methods: {
        save() {
            const model = JSON.parse(JSON.stringify(this.model))
            model.bid_configs = model.configs
            this.$store.dispatch('bidConfigsSave', model)
        },
        setTitle() {
            this.$store.dispatch('title', this.$t('BIDS.TITLE'))
        },
    },
}
</script>
<template lang="pug">
    tabs(v-if="model && model.services" ref="tabsCont" @changed="setTitle")
        tab(:name="service.translated" v-for="service in model.services" :key="service.id" :tabKey="'service-' + service.id")
            panel
                heading.mb-2(:level="5") {{$t('BIDS.CONFIG')}}
                tabs(:spacingX="0" :spacingY="0" @changed="setTitle")
                    tab.mb-0(:name="type.translated" v-for="type in orderTypes" :key="type.id" :tabKey="'types-' + type.id")
                        .separator-top
                        .bids-table
                            table
                                thead
                                    th
                                        .row.no-gutters
                                            .col-name
                                                small(v-html="$t('BIDS.PACK_NAME')")
                                            .col-input
                                                small(v-html="$t('BIDS.IS_BID_ENABLED')")
                                            .col-input
                                                small(v-html="$t('BIDS.IS_TRANSFER_ENABLED')")
                                            .col-slim
                                            .col-input
                                                small(v-html="$t('BIDS.BID_LIMIT')")
                                            .col-input
                                                small(v-html="$t('BIDS.BID_STEP')")
                                            .col-input
                                                small(v-html="$t('BIDS.BUYOUT_PRICE')")
                                            .col-slim
                                            .col-input
                                                small(v-html="$t('BIDS.PENALTY_GT_24')")
                                            .col-input
                                                small(v-html="$t('BIDS.PENALTY_12_24')")
                                            .col-input
                                                small(v-html="$t('BIDS.PENALTY_LT_12')")
                                tbody(v-if="model.configs && model.configs[service.slug] && model.configs[service.slug][type.id]")
                                    tr(v-for="(x, i) in model.configs[service.slug][type.id]")
                                        td
                                            .row.no-gutters
                                                .col-name(v-tooltip="{content: $t('BIDS.PACK_NAME'), trigger: 'click', classes: 'table-tooltip' }")
                                                    span.text-nowrap {{ x.packetName }}
                                                .col-input(v-tooltip="{content: $t('BIDS.IS_BID_ENABLED'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-switch(v-model="model.configs[service.slug][type.id][i].is_bid_enabled" :disabled="isDisabled")
                                                .col-input(v-tooltip="{content: $t('BIDS.IS_TRANSFER_ENABLED'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-switch(v-model="model.configs[service.slug][type.id][i].is_transfer_enabled" :disabled="isDisabled")
                                                .col-slim
                                                .col-input(v-tooltip="{content: $t('BIDS.BID_LIMIT'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-line.mb-0(size="sm" v-model="model.configs[service.slug][type.id][i].bid_limit" :disabled="isDisabled")
                                                .col-input(v-tooltip="{content: $t('BIDS.BID_STEP'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-line.mb-0(size="sm" v-model="model.configs[service.slug][type.id][i].bid_step" :disabled="isDisabled")
                                                .col-input(v-tooltip="{content: $t('BIDS.BUYOUT_PRICE'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-line.mb-0(size="sm" v-model="model.configs[service.slug][type.id][i].buyout_price" :disabled="isDisabled")
                                                .col-slim
                                                .col-input.bg-warning-1-05(v-tooltip="{content: $t('BIDS.PENALTY_GT_24'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-line.mb-0(size="sm" v-model="model.configs[service.slug][type.id][i].penalty_gt_24" :disabled="isDisabled")
                                                .col-input.bg-warning-1-05(v-tooltip="{content: $t('BIDS.PENALTY_12_24'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-line.mb-0(size="sm" v-model="model.configs[service.slug][type.id][i].penalty_12_24" :disabled="isDisabled")
                                                .col-input.bg-warning-1-05(v-tooltip="{content: $t('BIDS.PENALTY_LT_12'), trigger: 'click', classes: 'table-tooltip' }")
                                                    input-line.mb-0(size="sm" v-model="model.configs[service.slug][type.id][i].penalty_lt_12" :disabled="isDisabled")
                .row
                    .col-24.text-right
                        input-button(variant="success" @click="save" :disabled="isDisabled") {{$t('BASE.SAVE')}}
</template>
